import React from 'react';
import { SquareSvgProps } from '@icons/icon.types';

function EmailIcon({ title, size = 25, fillColor = '#2D3049', ...props }: SquareSvgProps) {
  return (
    <svg fill="white" height={size} viewBox="0 0 25 25" width={size} xmlns="http://www.w3.org/2000/svg" {...props}>
      {title && <title>{title}</title>}
      <path
        d="M3.5 7.5C3.5 6.96957 3.71071 6.46086 4.08579 6.08579C4.46086 5.71071 4.96957 5.5 5.5 5.5H19.5C20.0304 5.5 20.5391 5.71071 20.9142 6.08579C21.2893 6.46086 21.5 6.96957 21.5 7.5V17.5C21.5 18.0304 21.2893 18.5391 20.9142 18.9142C20.5391 19.2893 20.0304 19.5 19.5 19.5H5.5C4.96957 19.5 4.46086 19.2893 4.08579 18.9142C3.71071 18.5391 3.5 18.0304 3.5 17.5V7.5Z"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M3.5 7.5L12.5 13.5L21.5 7.5"
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

export { EmailIcon };
